import React, { Component, Fragment } from "react";
import { TransactionsComponent } from "../../components/TransactionsComponent";
import { Loader } from "../../components/Loader";
import { UsersComponent } from "../../components/UsersComponent";
import UserCard from '../../components/UserCard'
import { connect } from "react-redux";
import {
  getTransactions,
  getSuccessfulTransactions,
} from "../../actions/transactions";
import { getAllUsers } from "../../actions/users";

class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
    };
  }

  componentDidMount() {
    // this.setState({ loading: this.props.loading });
    setTimeout(() => {
      this.props.getTransactions();
      this.props.getSuccessfulTransactions();
      this.props.getAllUsers();
    }, 500);
  }
  
  render() {
    return (
      <Fragment>
        {(() => {
          if (this.props.loading) return <Loader />;
          else
            return this.props.user.admin_level >= 1 ? (
              <div className="container">
                <div className="row m-0 p-0">
                  <div className="col-md-12 m-0 p-0">
                    <div className="dashboard-header-wrapper">
                      <h3 className="dashboard-header-text">Dashboard</h3>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-3">
                    <div className="dashboard-card">
                      <div className="dashboard-card-header">
                        <h4>Total Spent</h4>
                        <i className="las la-ellipsis-v"></i>
                      </div>
                      <div className="dashboard-card-body">
                        <div className="card-body-icon-wrapper">
                          <i className="las la-file-invoice-dollar"></i>
                        </div>
                        <div className="card-body-info-wrapper">
                          <h5>{this.props.totalSuccessful}</h5>
                          <small>Spent All time</small>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="dashboard-card">
                      <div className="dashboard-card-header">
                        <h4>Users</h4>
                        <i className="las la-ellipsis-v"></i>
                      </div>
                      <div className="dashboard-card-body">
                        <div className="card-body-icon-wrapper">
                          <i className="las la-users"></i>
                        </div>
                        <div className="card-body-info-wrapper">
                          <h5>{this.props.users.length}</h5>
                          <small>Spent All time</small>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="dashboard-card">
                      <div className="dashboard-card-header">
                        <h4>Vouchers</h4>
                        <i className="las la-ellipsis-v"></i>
                      </div>
                      <div className="dashboard-card-body">
                        <div className="card-body-icon-wrapper">
                          <i className="las la-credit-card"></i>
                        </div>
                        <div className="card-body-info-wrapper">
                          <h5>256</h5>
                          <small>Spent All Count</small>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="dashboard-card">
                      <div className="dashboard-card-header">
                        <h4>Transactions</h4>
                        <i className="las la-ellipsis-v"></i>
                      </div>
                      <div className="dashboard-card-body">
                        <div className="card-body-icon-wrapper">
                          <i className="las la-file-invoice-dollar"></i>
                        </div>
                        <div className="card-body-info-wrapper">
                          <h5>{this.props.transactions.length}</h5>
                          <small>Spent All time</small>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* total volume */}
                  <div className="col-md-3">
                    <div className="dashboard-card">
                      <div className="dashboard-card-header">
                        <h4>Total Volume</h4>
                        <i className="las la-ellipsis-v"></i>
                      </div>
                      <div className="dashboard-card-body">
                        <div className="card-body-icon-wrapper">
                          <i className="las la-pause-circle"></i>
                        </div>
                        <div className="card-body-info-wrapper">
                          <h5>{this.props.totalVolume}</h5>
                          <small>Spent All time</small>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="dashboard-card">
                      <div className="dashboard-card-header">
                        <h4>Approved Users</h4>
                        <i className="lar la-ellipsis-v"></i>
                      </div>
                      <div className="dashboard-card-body">
                        <div className="card-body-icon-wrapper">
                          <i className="las la-thumbs-up"></i>
                        </div>
                        <div className="card-body-info-wrapper">
                          <h5>2516</h5>
                          <small>Spent All time</small>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="dashboard-card">
                      <div className="dashboard-card-header">
                        <h4>Unused Vouchers</h4>
                        <i className="las la-ellipsis-v"></i>
                      </div>
                      <div className="dashboard-card-body">
                        <div className="card-body-icon-wrapper">
                          <i className="las la-gift"></i>
                        </div>
                        <div className="card-body-info-wrapper">
                          <h5>2516</h5>
                          <small>Spent All time</small>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="dashboard-card">
                      <div className="dashboard-card-header">
                        <h4>Used Vouchers</h4>
                        <i className="las la-ellipsis-v"></i>
                      </div>
                      <div className="dashboard-card-body">
                        <div className="card-body-icon-wrapper">
                          <i className="las la-coins"></i>
                        </div>
                        <div className="card-body-info-wrapper">
                          <h5>2516</h5>
                          <small>Spent All time</small>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-8">
                    <TransactionsComponent
                      transactions={this.props.transactions}
                      isDashboard={true}
                    />
                  </div>
                  <div className="col-md-4">
                    <UsersComponent
                      users={this.props.users}
                      loading={this.props.usersLoading}
                    />
                  </div>
                </div>
              </div>
            ) : (
              <UserCard user={this.props.user} />
            );
        })()}
      </Fragment>
    );
  }
}
const mapStateToProps = (state) => ({
  transactions: state.transactions.transactions,
  totalVolume: state.transactions.totalVolume,
  totalSuccessful: state.transactions.totalSuccessful,
  loading: state.transactions.loading,
  users: state.users.users,
  usersLoading: state.users.loading,
  user: state.users.user
});
export default connect(mapStateToProps, {
  getTransactions,
  getSuccessfulTransactions,
  getAllUsers,
})(Dashboard);
